// src/pages/Dashboard/components/CasePanel/ClientDataSection/ClientDataSection.js

import React, { useState, useCallback } from 'react';
import ClientDataDisplay from './ClientDataDisplay';
import { getDadosCliente } from '../../../utils/clientDataProcessor';
import './ClientDataSection.css';

/**
 * Seção de dados do cliente com tabs
 * @param {object} caso - Caso selecionado
 * @param {boolean} debugMode - Se modo debug está ativo
 */
const ClientDataSection = ({ caso, debugMode = false }) => {
  const [activeTab, setActiveTab] = useState('cliente');
  const [dadosClienteVisivel, setDadosClienteVisivel] = useState(false);

  const handleReload = useCallback(() => {
    console.log('🔄 Forçando atualização dos dados do cliente...');
    setDadosClienteVisivel(false);
    setTimeout(() => setDadosClienteVisivel(true), 100);
  }, []);

  const handleCopy = useCallback(async () => {
    try {
      const dados = getDadosCliente(caso, debugMode);
      await navigator.clipboard.writeText(dados);
      alert('Dados copiados!');
    } catch (error) {
      console.error('Erro ao copiar:', error);
      alert('Erro ao copiar dados');
    }
  }, [caso, debugMode]);

  const dadosCliente = getDadosCliente(caso, debugMode);

  return (
    <div className="secao-dados-cliente">
      <h3>Dados do Cliente e Processo</h3>
      <div className="tabs-cliente">
        <button 
          className={`tab-cliente ${activeTab === 'cliente' ? 'active' : ''}`}
          onClick={() => setActiveTab('cliente')}
        >
          Cliente
        </button>
        <button 
          className={`tab-cliente ${activeTab === 'anexos' ? 'active' : ''}`}
          onClick={() => setActiveTab('anexos')}
        >
          Anexos
        </button>
        <button 
          className={`tab-cliente ${activeTab === 'processo' ? 'active' : ''}`}
          onClick={() => setActiveTab('processo')}
        >
          Processo
        </button>
      </div>
      <div className="tab-content">
        {activeTab === 'cliente' && (
          <div className="dados-cliente-content">
            {!dadosClienteVisivel ? (
              <div 
                className="click-to-view"
                onClick={() => setDadosClienteVisivel(true)}
              >
                Dados do Cliente (clicar para revelar)
              </div>
            ) : (
              <ClientDataDisplay
                dadosCliente={dadosCliente}
                onReload={handleReload}
                onCopy={handleCopy}
              />
            )}
          </div>
        )}
        {activeTab === 'anexos' && (
          <div className="em-construcao">Em construção</div>
        )}
        {activeTab === 'processo' && (
          <div className="em-construcao">Em construção</div>
        )}
      </div>
    </div>
  );
};

export default ClientDataSection;